import InvoiceRemark from './InvoiceRemark';

class NonAllowedOfficeHourSupplementRemark extends InvoiceRemark {
    ProcedureCode: string;
    NomenclatureNumber: string;

    info(t: Function): React.ReactElement {
        return <p> {t('Supplement')} {this.NomenclatureNumber} {t('for')} {this.ProcedureCode}</p>;
    }

    constructor(procedureCode: string, nomenclatureNumber: string) {
        super();
        this.ProcedureCode = procedureCode;
        this.NomenclatureNumber = nomenclatureNumber;
    }
}

export default NonAllowedOfficeHourSupplementRemark;
